export { default } from "./useTeacherSubjectGet";
